export { isGoalPremium, isGoalUnlockable, contentScoreCutoffs }

const contentScoreCutoffs = {
  goalMin: 0.0,
  goalUnlockableMin: 2.0,
  goalTrialMin: 3.0,
  goalMax: 3.999,
  anchorMin: 4.0,
  anchorUnlockableMin: 5.0,
  anchorTrialMin: 6.0,
  anchorMax: 6.999
}

function isGoalPremium({ super_page, score }) {
  let anchorPremiumCutoff = contentScoreCutoffs.anchorUnlockableMin

  return super_page
    ? score < anchorPremiumCutoff && score >= contentScoreCutoffs.anchorMin
    : score < contentScoreCutoffs.goalUnlockableMin
}

function isGoalUnlockable({ super_page, score }) {
  return super_page
    ? score < contentScoreCutoffs.anchorTrialMin && score >= contentScoreCutoffs.anchorUnlockableMin
    : score < contentScoreCutoffs.goalTrialMin && score >= contentScoreCutoffs.goalUnlockableMin
}
